import React, { useState } from 'react'

export default function MyTabs({tabList, currentTab, onTabChange}) {
  //console.log('MyTabs', tabList);
  const [tab, setTab] = useState(currentTab);

  function tabClicked(ix) {
    //console.log('tabClicked', ix);
    setTab(ix);
    onTabChange(ix);
  }

  return (
    <div className='w-full mx-3 flex flex-shrink-0 flex-row justify-start'>
        {tabList.map((t,ix) => {
            const bg = (ix === tab) ? ' bg-green-400' : '';
            return (
                <div
                    key={ix}
                    onClick={()=>tabClicked(ix)} 
                    className={'max-h-10 px-4 border-2 border-green-400 rounded-t-md text-2xl font-semibold text-center'+bg}>
                    {t}
                </div>
            )
        })}
    </div>
  )
}
